/**
 * Search the highest number for a pattern 'name (number)' to help naming created objects
 * @param name base name
 * @param array array of names
 * @returns highest number
 */
export function getHighestNumberForName(name: string, array: string[]): number {
    let highest = 0; // Default to 0 if no matches are found

    for (const item of array) {
        // Match the pattern: `name (number)`
        const regex = new RegExp(`^${name} \\((\\d+)\\)$`);
        const match = item.match(regex);

        if (match) {
            // Extract the number and update `highest` if it's greater
            const number = Number.parseInt(match[1], 10);
            if (number > highest) {
                highest = number;
            }
        }
    }

    return highest;
}
